<template>
  <div class="table-responsive" :class="{ 'tbl-inherit': overflowState }">
    <div class="row">
      <div class="col-sm-3">
        <Alert type="danger" :messages="errors" />
      </div>
    </div>
    <div style="width: 100%; overflow-x: visible;">
      <table class="table" v-show="!loading">
        <thead>
          <tr>
            <th class="" style="width: 40px!important;">
              <!--<span @click="checkAll()" style="cursor:pointer;">全て選択</span>-->
              <!-- <input type="checkbox"  v-model="isCheckAll" @click="checkAll()"  style="width: 18px;height: 18px;margin-left: 5px;"/> -->
            </th>
            <th></th>
            <template>
              <th
                v-on:click="sorting('reviewListAddedDate')"
                class="text-center arrow-link"
                style="min-width: 100px !important; max-width: 100px !important;"
                v-if="!isReviewer"
              >
                {{ 'リスト振分日' }}
                <i
                  class="fa fa-long-arrow-up"
                  :class="{ active: sortBy == 'reviewListAddedDate' }"
                  aria-hidden="true"
                ></i>
                <i
                  class="fa fa-long-arrow-down"
                  :class="{ active: sortBy == '-reviewListAddedDate' }"
                  aria-hidden="true"
                ></i>
              </th>
              <th
                v-on:click="sorting('joinedDate')"
                class="text-center arrow-link"
              >
                {{ isReviewer ? '登録/更新日' : '登録日' }}
                <i
                  class="fa fa-long-arrow-up"
                  :class="{ active: sortBy == 'joinedDate' }"
                  aria-hidden="true"
                ></i>
                <i
                  class="fa fa-long-arrow-down"
                  :class="{ active: sortBy == '-joinedDate' }"
                  aria-hidden="true"
                ></i>
              </th>
              <!-- <th
                class="text-center"
                v-bind:key="menu.title"
                v-else-if="menu.title == '経由' && menu.display == true"
              >
              <span v-show="!isReviewer">経由</span>
                <b-dropdown
                  id="ddown-aria"
                  text="経由"
                  variant="primary"
                  class="m-2 th-dropdown btn-plain-dv"
                  @hidden="search"
                  @shown="overflow"
                  v-show="isReviewer"
                >
                  <div>
                    <div class="form-check">
                      <input
                        type="checkbox"
                        id="own"
                        value="own"
                        class="form-check-input"
                        v-model="companyModel"
                      />
                      <label class="form-check-label">自社HP経由</label>
                    </div>
                    <div class="form-check">
                      <input
                        type="checkbox"
                        id="other"
                        value="other"
                        class="form-check-input"
                        v-model="companyModel"
                      />
                      <label class="form-check-label">他ルート経由</label>
                    </div>
                  </div>
                </b-dropdown>
              </th> -->
              <th class="text-center arrow-link">
                登録者情報
                <!-- <i
              class="fa fa-long-arrow-up"
              :class="{'active': sortKey == 'last_furigana' && asc}"
              aria-hidden="true"
            ></i>
            <i
              class="fa fa-long-arrow-down"
              :class="{'active': sortKey == 'last_furigana' && !asc}"
              aria-hidden="true"
                ></i>-->
              </th>
              <th class="text-center arrow-link">
                在籍企業 / 直近職種
                <!-- <i
                  class="fa fa-long-arrow-up"
                  :class="{'active': sortBy == '-birth_date'}"
                  aria-hidden="true"
                ></i>
                <i
                  class="fa fa-long-arrow-down"
                  :class="{'active': sortBy == 'birth_date'}"
                  aria-hidden="true"
                ></i> -->
              </th>
              <th class="text-center">登録者がスカウトを希望している求人</th>
              <!-- <th class="text-center">スカウトする求人</th> -->
            </template>

            <th class="text-center">メモ</th>
            <th class="text-center">ステータス</th>
            <!-- <th class="text-center">判定</th> -->
            <th class="text-center"></th>
          </tr>
        </thead>
        <tbody>
          <ApplicantRow
            v-for="(applicant, index) in applicants"
            v-bind:key="applicant.id"
            :applicant="applicant"
            :applicantIndex="index"
            :rowNumber="rowNumber(index)"
            @hidden="overflowState = 0"
            @shown="overflow"
            @changed="checkUncheckJobseeker"
            :isPreview="true"
          />
          <tr v-if="showEmptyMessage">
            <td colspan="100%" class="text-center">
              登録者が見つかりませんでした
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="pagination-area" v-if="totalPages > 1">
      <paginate :total-page="totalPages" :callback="changePage" />
    </div>
    <Loader v-show="loading" />
  </div>
</template>

<script>
/* eslint-disable */

import ApplicantRow from '../applicants/ApplicantRow.vue';
import Loader from '@/components/utils/Loader.vue';
import Paginate from '@/components/utils/Paginate.vue';
import { mapMutations, mapActions, mapState, mapGetters } from 'vuex';
import actions from '@/config/actions';
import mutations from '@/config/mutations';
import Api from '@/config/api';
import ApiService from '@/service/apiService';
import Alert from '@/components/utils/Alert.vue';

export default {
  name: 'ApplicantPreviewList',
  components: { Paginate, Loader, ApplicantRow, Alert },
  data() {
    return {
      // childJobModel: [],
      isPreview: true,
      loading: false,
      pagination: {},
      sortKey: null,
      asc: true,
      // mainJobModel: [],
      overflowState: 0,
      errors: [],
      isCheckAll: false,
      jobseekerIds: [],
      perPageRows: ['20件', '50件'],
      client_status_list: [
        '未確認',
        '選考対象外',
        '選考対象、未対応',
        '確認中',
        '過去応募済み',
        'コンタクト済み',
        '返信有',
        // 'プッシュ済',

        // '応募有',
        '選考応募有',
        'システム取込み済み',

        '選考NG',
        '中長期的対応',
        'その他',
      ],
      showEmptyMessage: false,
    };
  },

  beforeCreate() {
    import('../applicants/ApplicantRow.vue')
      .then((module) => {
        this.$options.components.ApplicantRow = module.default;
      })
      .catch((error) => {
        console.error('Error loading ApplicantRow:', error);
      });
  },
  created() {
    this.$options.components.ApplicantRow = require('../applicants/ApplicantRow.vue');
    if (this.mainJobModel.length > 0) {
      this.mainJobModelChanged(this.mainJobModel);
      this.search();
    } else {
      // this.load();
      this.setPreviewListSearchParams({ status: ['確認中'] });
      this.load(this.buildParams(1));
    }
    this.loadMenuConfigurations();
  },
  // mounted(){
  //   console.log(this.isReviewer);
  //   if(!this.isReviewer) this.setStatusModel(['社内確認待ち']);
  //   console.log(this.statusModel);
  // },
  computed: {
    ...mapGetters({
      getChildJobModel: 'getChildJobModel',
      getMainJobModel: 'getMainJobModel',
      getEnglishSkillModel: 'getEnglishSkillModel',
      getStatusModel: 'getStatusModel',
      getClientStatus: 'getClientStatus',
      getColorModel: 'getColorModel',
      getClientColor: 'getClientColor',
      getCompanyModel: 'getCompanyModel',
      getMenus: 'getMenus',
      reviewLists: 'getReviewLists',
      isAdmin: 'currentUserIsAdmin',
      isReviewer: 'isCreateReviewUser',
      getReviewListModel: 'getReviewListModel',
    }),
    ...mapState({
      reloadApplicants: ({ applicant }) => applicant.reloadApplicants,
      applicants: ({ applicant }) => applicant.applicants,
      activeCategory: ({ applicant }) => applicant.activeCategory,
      favoritesOnly: ({ applicant }) => applicant.favoritesOnly,
      interviewsOnly: ({ applicant }) => applicant.interviewsOnly,
      searchParams: ({ applicant }) => applicant.previewListSearchParams,
      sortBy: ({ applicant }) => applicant.sortBy,
      page: ({ applicant }) => applicant.page,
      occupations: ({ applicant }) => applicant.selectors.occupations || [],
      englishSkills: ({ applicant }) => applicant.selectors.englishSkills || [],
    }),
    reviewListModel: {
      get() {
        return this.getReviewListModel;
      },
      set(value) {
        this.setReviewListModel(value);
      },
    },
    mainJobModel: {
      get() {
        return this.getMainJobModel;
      },
      set(value) {
        this.setMainJobModel(value);
      },
    },
    childJobModel: {
      get() {
        return this.getChildJobModel;
      },
      set(value) {
        this.setChildJobModel(value);
      },
    },
    englishSkillModel: {
      get() {
        return this.getEnglishSkillModel;
      },
      set(value) {
        this.setEnglishSkillModel(value);
      },
    },
    statusModel: {
      get() {
        return this.getStatusModel;
      },
      set(value) {
        this.setStatusModel(value);
      },
    },
    colorModel: {
      get() {
        return this.getColorModel;
      },
      set(value) {
        this.setColorModel(value);
      },
    },
    companyModel: {
      get() {
        return this.getCompanyModel;
      },
      set(value) {
        this.setCompanyModel(value);
      },
    },
    totalPages() {
      const { pagination } = this;
      return pagination.total
        ? Math.ceil(pagination.total / pagination.perPage)
        : 0;
    },
    from() {
      return (
        (parseInt(this.pagination.current, 10) - 1) * this.pagination.perPage +
        1
      );
    },
    to() {
      return (
        (parseInt(this.pagination.current, 10) - 1) * this.pagination.perPage +
        this.applicants.length
      );
    },
  },
  methods: {
    ...mapActions([
      actions.applicant.LOAD_APPLICANTS,
      actions.applicant.LOAD_SELECTORS,
      'loadPreviewApplicants',
      'loadMenuConfigurations',
      'loadReviewLists',
    ]),
    ...mapMutations([
      mutations.applicant.SET_APPLICANTS,
      mutations.applicant.CHANGE_SORT_COLUMN,
      mutations.applicant.CHANGE_SEARCH_PARAMS,
      mutations.applicant.SET_SELECTORS,
      'setPreviewApplicants',
      'setPreviewApplicantCounts',
      'setPreviewListSearchParams',
      'setApplicantCounts',
      'setPage',
      'setChildJobModel',
      'setMainJobModel',
      'setEnglishSkillModel',
      'setStatusModel',
      'setCompanyModel',
      'mutateApplicantsAfterMultipleStatus',
      'updateMainJobModel',
      'setColorModel',
      'setReviewListModel',
      'mutateApplicantsAfterMultipleReviewList',
      'setReloadApplicants',
      'setCurrentPageApplicants',
    ]),
    overflow() {
      this.overflowState = 1;
    },
    checkAll() {
      this.isCheckAll = !this.isCheckAll;
      this.jobseekerIds = [];
      if (this.isCheckAll) {
        // Check all
        for (var key in this.applicants) {
          this.jobseekerIds.push(this.applicants[key].id);
        }
      }
    },
    isCheckedJobseeker(id) {
      return this.jobseekerIds.includes(id);
    },
    isCheckedApplicants() {
      return this.jobseekerIds.length ? true : false;
    },
    checkUncheckJobseeker(id) {
      const index = this.jobseekerIds.indexOf(id);
      if (index > -1) {
        this.jobseekerIds.splice(index, 1);
      } else {
        this.jobseekerIds.push(id);
      }
    },
    changeStatus(status) {
      this.errors = [];
      if (this.jobseekerIds.length == 0) {
        this.errors.push('登録者が選択されていません');
      } else {
        this.loading = true;
        ApiService.put(Api.endpoints.MULTIPLE_STATUS, {
          jobseekerIDs: this.jobseekerIds,
          status: status,
        })
          .then(({ data }) => {
            // console.log(data.data)
            this.mutateApplicantsAfterMultipleStatus(data.data);
          })
          .catch(({ response }) => this.parseErrorResponse(response))
          .then(() => {
            this.loading = false;
            this.jobseekerIds = [];
            this.isCheckAll = false;
          });
      }
    },
    assignToReviewList() {
      this.errors = [];
      if (this.jobseekerIds.length == 0) {
        this.errors.push('登録者が選択されていません');
      } else {
        this.loading = true;
        let list = this.getReviewListModel;
        if (
          !this.getReviewListModel ||
          (this.getReivewListModel && !this.getReviewListModel.length)
        ) {
          list = null;
        }
        ApiService.put(Api.endpoints.MULTIPLE_REVIEW_LIST, {
          jobseekerIDs: this.jobseekerIds,
          list: list,
        })
          .then(({ data }) => {
            this.mutateApplicantsAfterMultipleReviewList(data.data);
            this.mutateApplicantsAfterMultipleStatus(data.data);
          })
          .catch((error) => console.log(error.response))
          .then(() => {
            this.loading = false;
            this.jobseekerIds = [];
            this.setReviewListModel([]);
          });
      }
      this.loading = false;
    },
    changePerPage(row) {
      const params = { rowPerPage: row == '20件' ? 20 : 50 };

      if (this.searchParams) Object.assign(params, this.searchParams);
      if (this.sortBy) Object.assign(params, { sortBy: this.sortBy });
      this.load(params);
    },
    sorting(key) {
      let column = '';
      if (this.sortKey !== null) {
        if (this.sortKey === key) {
          if (this.asc) {
            column = key;
            this.asc = false;
          } else {
            column = `-${key}`;
            this.asc = true;
          }
        } else {
          column = `-${key}`;
          this.asc = true;
        }
      } else {
        column = `-${key}`;
        this.asc = true;
      }
      this.sortKey = key;
      this[mutations.applicant.CHANGE_SORT_COLUMN](column);
      // this.setPage(1);
    },
    async load(params = {}) {
      this.loading = true;
      this.errors = [];
      this[actions.applicant.LOAD_SELECTORS]()
        .then(({ data }) => {
          this[mutations.applicant.SET_SELECTORS](data.data);
        })
        .catch(({ response }) => this.parseErrorResponse(response))
        .then(() => this.setReloadApplicants(false));

      this.loadReviewLists();

      params.review_list_id= this.$route.params.id
      let res = await this.loadPreviewApplicants(params);
      this[mutations.applicant.SET_APPLICANTS](res.data.data);
      this.setCurrentPageApplicants(res.data.data);
      this.showEmptyMessage = this.applicants.length === 0;
      this.pagination = res.data.meta.pagination || {};
      this.statusModel = this.searchParams.status
        ? this.searchParams.status
        : this.statusModel;

      this.showcount();
      this.loading = false;
    },
    buildParams(page = null) {
      const params = {};
      if (page) params.page = page;
      console.log(this.searchParams);
      // if (this.activeCategory) params.category = this.activeCategory;
      if (this.pagination.perPage == 50) params.rowPerPage = 50;
      if (this.favoritesOnly) params.favorites = 1;
      if (this.interviewsOnly) params.interviews = 1;
      if (this.searchParams) Object.assign(params, this.searchParams);
      if (this.sortBy) params.sort = this.sortBy;
      params.isNewPanel = true;
      // if(!this.isReviewer) this.setStatusModel(['社内確認待bち']);
      // if (!this.isReviewer && (this.statusModel && !this.statusModel.length)) params.status = ['社内確認待ち']
      return params;
    },
    changePage(page) {
      this.setPage(page);
      // this.load(this.buildParams(page));
    },
    rowNumber(index) {
      return (
        index +
        1 +
        (parseInt(this.pagination.current, 10) - 1) * this.pagination.perPage
      );
    },
    showcount() {
      this.setApplicantCounts({
        total: this.pagination.total,
        from: this.from,
        to: this.to,
        perPage: this.pagination.perPage,
      });
    },
    isChecked(id) {
      if (this.mainJobModel.indexOf(id) !== -1) return true;
      return false;
    },
    search() {
      const params = {};
      Object.assign(params, this.searchParams);
      params.childOccupations = this.childJobModel;
      params.englishSkills = this.englishSkillModel;
      params.status = this.statusModel;
      params.regcompany = this.companyModel;
      params.client_color = this.colorModel;
      if (params.childOccupations.length === 0) delete params.childOccupations;
      if (params.englishSkills.length === 0) delete params.englishSkills;
      this.setPreviewListSearchParams(params);
      this.overflowState = 0;
    },
  },
  watch: {
    reloadApplicants: function() {
      if (this.page === 1) {
        this.load(this.buildParams(1));
      } else {
        this.setPage(1);
      }
    },
    // eslint-disable-next-line
    activeCategory(categories) {
      // let self = this;
      // this.childJobModel = [];
      // this.occupations.forEach(function(occ) {
      //   if(categories.indexOf(occ.id) !== -1) {
      //     occ.children.forEach(function(child) {
      //       self.childJobModel.push(child._id);
      //     });
      //   }
      // });
      // this.searchParams.childOccupations = this.childJobModel;
      // let params = this.searchParams;
      // Object.keys(params).forEach(key => !params[key] && delete params[key]);
      // this[mutations.applicant.CHANGE_SEARCH_PARAMS](params);
      // this.load(this.buildParams());
      if (this.page === 1) this.load(this.buildParams(1));
      else this.setPage(1);
    },
    // eslint-disable-next-line
    favoritesOnly: function() {
      if (this.page === 1) this.load(this.buildParams(1));
      else this.setPage(1);
    },
    interviewsOnly: function() {
      if (this.page === 1) this.load(this.buildParams(1));
      else this.setPage(1);
    },
    // eslint-disable-next-line
    searchParams: function() {
      if (this.page === 1) this.load(this.buildParams(1));
      else this.setPage(1);
    },
    // eslint-disable-next-line
    page: function(currentPage) {
      this.load(this.buildParams(currentPage));
    },
    // eslint-disable-next-line
    sortBy: function(value) {
      if (this.page === 1) this.load(this.buildParams(1));
      else this.setPage(1);
    },
    mainJobModel(mainJobs) {
      this.updateMainJobModel({ mainJobs });
    },
  },
};
</script>
<style scoped>
.client-listing-detail table th a {
  color: #036d6c;
  font-size: 12px;
  text-decoration: none !important;
}

.color-th >>> .btn {
  min-width: 10px !important;
}

.color-th >>> .dropdown-menu {
  min-width: 150px;
}
.arrow-link i {
  color: #d0c2c2;
}
.arrow-link i.active {
  color: #036d6c;
}
.reviewer {
  background: none !important;
  color: #036d6c;
  border: none !important;
  font-size: 12px;
  font-weight: 600;
  padding: 5px 0 5px 0;
}
.reviewer:hover {
  background: none !important;
  color: #036d6c !important;
}
.th-dropdown-text {
  display: inline-block;
  min-width: 180px; /* or your desired width */
}

tbody tr {
  cursor: pointer;
  border: 2px;
}
th.arrow-link:hover {
  cursor: pointer;
  padding: 5px 7px !important;
}

.table-responsive {
  overflow-x: visible;
}
</style>
